export default function IconBackArrow() {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_167_858)">
        <path
          d="M3.62924 4.6218L3.55957 4.68194L0.180755 8.06075C-0.0397797 8.28129 -0.0598297 8.62639 0.120608 8.86957L0.180755 8.93925L3.55957 12.3181C3.80216 12.5606 4.19547 12.5606 4.43806 12.3181C4.65859 12.0975 4.67864 11.7524 4.4982 11.5092L4.43806 11.4396L2.15 9.15H15.35C15.709 9.15 16 8.85898 16 8.5C16 8.17365 15.7595 7.90347 15.4461 7.85705L15.35 7.85L2.149 7.849L4.43806 5.56043C4.65859 5.3399 4.67864 4.9948 4.4982 4.75161L4.43806 4.68194C4.21752 4.46141 3.87242 4.44136 3.62924 4.6218Z"
          fill="#7E8681"/>
      </g>
      <defs>
        <clipPath id="clip0_167_858">
          <rect width="16" height="16" fill="white" transform="matrix(-1 0 0 1 16 0.5)"/>
        </clipPath>
      </defs>
    </svg>

  )
}
